


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { GenericItem } from '../../models/items/generic-item-model';
import StaticItemMap from '@/components/StaticItemMap.vue'

@Component({ components: { StaticItemMap  } })
export default class SmallItemCard extends Vue {
  @Prop(GenericItem) public item!: GenericItem;
  @Prop(Boolean) public link?: boolean;

  get shouldLink() {
    
    return !!this.link;
  }
}
